import { RematchDispatch, RematchRootState } from '@rematch/core';
import { connect } from 'react-redux';
import { RootModel } from '../../state';
import { TabContent } from './TabContent';

export const mapState = (state: RematchRootState<RootModel>) => ({
  service: state.services.service,
  defaultRoute: state.services.defaultRoute,
  project: state.projects.project,
  connection: state.connections.connection,
  iModel: state.imodels.iModel,
  embedUrl: state.tab.embedUrl,
  linkToUrl: state.tab.linkToUrl,
});

export const mapDispatch = (dispatch: RematchDispatch<RootModel>) => ({
  loadStateFromTabData: async (context: microsoftTeams.Context) =>
    dispatch.tab.loadStateFromTabData(context),
});

export const ConnectedTabContent = connect(mapState, mapDispatch)(TabContent);
